import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VerifyPhoneComponent } from './verify-phone/verify-phone.component';

const VERIFICATION_ROUTES: Routes = [{ path: 'phone', component: VerifyPhoneComponent, pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forChild(VERIFICATION_ROUTES)],
  exports: [RouterModule],
})
export class VerificationRoutingModule {}
